export default "__VITE_ASSET__IIH3FBvb__"